import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HeaderDirectory from './HeaderDirectory';
import RowDirectory from './RowDirectory';
import { StyledTableWrapper } from './style';

const SelectEmployerDirectory = ({ data, setEmployeeSelected, resetRow }) => {
  const [rowSelected, setRowSelected] = useState(0);
  useEffect(() => {
    if (resetRow) {
      setRowSelected(0);
    }
  });
  return (
    <StyledTableWrapper>
      <HeaderDirectory />
      {data.map((item, i) => (
        <RowDirectory
          key={`row-d-${i + 1}`}
          row={i + 1}
          dataRow={item}
          rowSelected={rowSelected}
          setRowSelected={setRowSelected}
          setEmployeeSelected={setEmployeeSelected}
        />
      ))}
    </StyledTableWrapper>
  );
};
SelectEmployerDirectory.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastname: PropTypes.string,
      profile: PropTypes.string,
      department: PropTypes.string,
      extension: PropTypes.number,
      phones: PropTypes.string,
      email: PropTypes.string
    })
  )
};

export default SelectEmployerDirectory;
